import { dxlCloudClient } from '@vfit/business-data-access';
import { API } from '@vfit/shared/data-access';
import { IScheduleRequest, IScheduleResponse } from './schedule.models';

export const awsSchedule = (payload: IScheduleRequest) =>
  dxlCloudClient.post(API.AWS_SCHEDULE, payload) as Promise<IScheduleResponse>;
